import { render, staticRenderFns } from "./EditorialReadonlyMainItem.vue?vue&type=template&id=2e2c5d36&scoped=true&"
import script from "./EditorialReadonlyMainItem.vue?vue&type=script&lang=js&"
export * from "./EditorialReadonlyMainItem.vue?vue&type=script&lang=js&"
import style0 from "./EditorialReadonlyMainItem.vue?vue&type=style&index=0&id=2e2c5d36&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e2c5d36",
  null
  
)

export default component.exports